module.exports = __webpack_public_path__ + "static/another-stock-7365953a7d06c25d600f9e87b1dea3fb.jpg";